export default __webpack_public_path__ + "static/media/wn_7_5.aa5420ef.webp";